import { Box } from "@mui/material";
import { DotLegalOverflowMenu, DotLegalOverflowMenuItem } from "@dotlegal/dotlegal-ui-components";

export interface BulkActionsMenuProps {
    items: Array<DotLegalOverflowMenuItem>;
}

/** The list toolbar's menu for entering bulk edit or bulk delete mode. */
function BulkActionsMenu(props: BulkActionsMenuProps) {
    return (
        // Matches the height of the other toolbar buttons beside it.
        <Box sx={{ "& .MuiButtonBase-root": { height: 38.5 } }}>
            <DotLegalOverflowMenu items={props.items} />
        </Box>
    );
}

export default BulkActionsMenu;
